module.exports = __webpack_public_path__ + "static/media/weekly575.dd0735ea.png";